import { render, staticRenderFns } from "./two-tone.vue?vue&type=template&id=07bf0cb8"
import script from "./two-tone.vue?vue&type=script&lang=js"
export * from "./two-tone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports